import BlackSignalGame from '../games/black-signal/js/BlackSignalGame.js';

window.onload = () => {
    new BlackSignalGame();
};
